/**
 * Locale-aware formatters.
 *
 * The locale-aware versions of `timeAgo`, `formatDateTime`, and
 * `formatTimestamp` live in `../lib/utils.ts` (next to `formatPhone` and
 * `formatDuration`) so existing call sites don't have to change. They are
 * re-exported here for code that prefers to read from the i18n entry point.
 */
import i18n from './index'

export { timeAgo, formatDateTime, formatTimestamp } from '../lib/utils'

const currencyCache = new Map<string, Intl.NumberFormat>()

/** USD currency formatted in the active locale. Currency stays USD; only
 *  thousands/decimal separators change (e.g. `1,234.56` vs `1.234,56`).
 *
 *  `fractionDigits` controls precision (default 2). Pass 4 for per-call cost
 *  rows that need sub-cent precision.
 */
export function formatCurrencyUSD(amount: number, fractionDigits: number = 2): string {
  const lang = i18n.language || 'en'
  const cacheKey = `${lang}:${fractionDigits}`
  let nf = currencyCache.get(cacheKey)
  if (!nf) {
    nf = new Intl.NumberFormat(lang, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    })
    currencyCache.set(cacheKey, nf)
  }
  return nf.format(amount)
}
